import { useQuery } from 'react-query';
import { getUsersByCompanyId } from '../../api/medtech-api';

interface UseUsersParams {
  companyId: number;
  isOpen: boolean;
}

export const useUsers = ({ companyId, isOpen }: UseUsersParams) => {
  return useQuery(['users', companyId], () => getUsersByCompanyId(companyId), {
    enabled: isOpen && !!companyId,
    select: (response) => response.data.filter((user) => user.role === 'quality' || user.role === 'normal'),
  });
};
